import { EncodeObject } from '@cosmjs/proto-signing';
import { create } from 'zustand';

import { ExecuteOptions } from './useExecuteChainModule';

interface Web3AuthModalStore {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  pendingExecution: {
    msgs: EncodeObject[];
    options?: ExecuteOptions;
  } | null;
  setPendingExecution: (
    pendingExecution: {
      msgs: EncodeObject[];
      options?: ExecuteOptions;
    } | null,
  ) => void;
}

export const useWeb3AuthModalStore = create<Web3AuthModalStore>(set => ({
  isOpen: false,
  setIsOpen: (isOpen: boolean) => set({isOpen}),
  pendingExecution: null,
  setPendingExecution: (
    pendingExecution: {
      msgs: EncodeObject[];
      options?: ExecuteOptions;
    } | null,
  ) => set({pendingExecution}),
}));
